// import EndLineDispatch from "../../../components/DispatchCentre/EndLineDispatch";

// const DispatchCentrePage =({userData})=>{
//     return(
//         <div>
//         <EndLineDispatch userData={userData}/>
//         </div>
//     )
// };

// export default DispatchCentrePage;

import { Typography, Divider } from "antd";
import EndLineDispatch from "../../../components/DispatchCentre/EndLineDispatch";

const DispatchCentrePage = ({ userData }) => {
  return (
    <div className="page-container">
      
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            End Of Line Dispatch
          </Typography.Title>
          <Typography.Text className="page-subtitle">
            Scan or enter Kanban to dispatch
          </Typography.Text>
        </div>
      </div>

      <Divider className="page-divider" />

      <EndLineDispatch userData={userData} />
    </div>
  );
};

export default DispatchCentrePage;